import React from "react";
import { useEffect } from "react";
import { useApp } from "../../../contexts";
import { useState } from "react";
import { itemsMyPurchase, itemsBreed } from "../../../services/app";
import ItemMerchandise from "../../../components/ItemMerchandise/myMerchandise";
import { SearchIcon } from "../../../components/Icons/SearchIcon";
import {
  paginationRender,
  PaginationView,
} from "../../../components/Table";
import { ModalDetail } from "./ModalDetail";
import useDebounce from "../../../hook/useDebounce";

const DEFAULT_PARAMS = {
  page: 1,
  size: 10,
  from: "mall",
};
export const TabContent = (props) => {
  const { T, setLoading, user, loading, language } = useApp();
  const { tab } = props;
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [filterText, $filterText] = useState("");
  const [dataTab, setDataTab] = useState([]);
  const [breedOptions, setBreedOptions] = useState([]);
  const [itemSelected, setItemSelected] = useState(null);
  const searchParms = { ...DEFAULT_PARAMS, from: props.tab };

  useEffect(() => {
    loadData();
    itemsBreed(9).then((res) => {
      if (res?.data?.data?.categories) {
        setBreedOptions(res?.data?.data?.categories || [])
      }
    })
  }, []);
  const debouneFilterText = useDebounce(filterText, 1000);
  
  const loadData = async (keyword, page) => {
    setLoading(true);
    const params = {...searchParms};
    if (keyword) {
      params.keyword = keyword;
    }else{
      delete params.keyword;
    }
    if (page) params.page = page;
    const result = await itemsMyPurchase(params);
    setDataTab(result?.data?.data?.rows || []);
    setTotal(result?.data?.data?.count || 0);
    setLoading(false);
  };

  const loadMore = async () => {
    setLoading(true);
    const result = await itemsMyPurchase({
      ...searchParms,
      page: page + 1,
    });
    setDataTab((prev) => [...prev, result?.data?.data?.rows] || []);
    setTotal(result?.data?.data?.count || 0);
    setPage(page + 1);
    setLoading(false);
  };
  useEffect(() => {
    setPage(1)
    loadData(debouneFilterText, 1);
  }, [debouneFilterText]);

  const handleSelectItem = (item) => {
    if (item.orders_item?.length == 0) return;
    setItemSelected(item)
  }
  const onChange = (page) => {
    setPage(page);
    loadData(null, page);
  };
  return (
    <div className="flex flex-col gap-[20px] lg:gap-[20px] mt-[10px]">
      <div className="search-input lg:mx-[15px] relative">
        <SearchIcon className="absolute left-[16px] top-[12px]" />
        <input
          type="text"
          className="h-[40px] outline-none pl-[50px] w-full max-w-full px-5 py-3 bg-white rounded-[10px] text-black "
          placeholder={T("Type anything to search")}
          onChange={(e) => $filterText(e.target.value)}
        />
      </div>

      <div className="asset-block lg:mx-[15px]">
        {dataTab?.length > 0 && (
          <div className="bg-[#FFF] rounded-[8px] lg:flex gap-[0px] items-center px-[27px] py-[20px] mb-[30px] hidden">
            <div className="w-[60%]">{T("Order")}</div>
            <div className="w-[40%] grid grid-cols-3 gap-[30px]">
              <div className="flex justify-center">{T("Status")}</div>
              <div className="flex justify-center">{T("Quantity")}</div>
              <div className="flex justify-center">{T("Total")}</div>
            </div>
          </div>
        )}
        {dataTab?.length > 0 ? (
          <>
            <div className="asset-block-items-purchase">
              {dataTab.map((item, index) => (
                <ItemMerchandise
                  key={index}
                  itemData={item}
                  breedOptions={breedOptions}
                  selectItem={() => handleSelectItem(item)}
                />
              ))}
            </div>
            <div className="flex justify-center">
              <PaginationView
                current={page}
                pageSize={10}
                onChange={(p, ps) => {
                  onChange(p);
                }}
                total={total}
                itemRender={paginationRender}
              />
            </div>
          </>
        ) : !!filterText && !loading ? (
          <>
            <div className="text-[#818181] text-sm flex-wrap lg:text-base flex justify-center items-center">
              <div className="w-full flex items-center lg:mt-[80px] mb-[16px] justify-center">
                <img
                  className="w-[100px] lg:w-[160px]"
                  src={"/assets/images/empty-table.png"}
                  alt=""
                />
              </div>
              <div className="w-full flex justify-center mb-[15px]">
                {T("No results.")}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="text-[#818181] text-sm flex-wrap lg:text-base flex justify-center items-center">
              <div className="w-full flex items-center lg:mt-[80px] mb-[16px] justify-center">
                <img
                  className="w-[100px] lg:w-[160px]"
                  src={"/assets/images/empty-table.png"}
                  alt=""
                />
              </div>
              <div className="w-full flex justify-center mb-[15px]">
                {T("You haven't got anything yet.")}
              </div>
              <a
                href={`${user.store_shopify}?lang=${user.language}`}
                target="_blank"
                rel="noreferrer"
                className="bg-black leading-[45px] !text-white rounded-[15px] px-[20px] h-[45px] button-boxshadow"
              >
                {T("Go to Mall")}
              </a>
            </div>
          </>
        )}
      </div>
      {/* {total > page * DEFAULT_PARAMS.size && (
        <>
          <div
            className="flex justify-center items-center gap-[10px]  mt-[40px]"
            onClick={() => loadMore()}
          >
            {T("Load more")} <ArrowDownIcon />
          </div>
        </>
      )} */}
      {itemSelected && (
        <ModalDetail
          breedOptions={breedOptions}
          data={itemSelected}
          title={T("Order Detail")}
          tab={tab}
          onClose={() => setItemSelected(null)}
        />
      )}
    </div>
  );
};
